/**
 * Ryan O'Dowd
 * 2025-06-08
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Tooltip as PaperTooltip,
} from 'react-native-paper';
/* @TODO:
import {
  Platform,
} from 'react-native';
*/
import React from 'react';
// @TODO: import globals from '@utils/globals';

const Tooltip = (props: React.ComponentProps<typeof PaperTooltip>) => {
  // @TODO: if native or mobile web, return popover instead?

  return (
    <PaperTooltip
      leaveTouchDelay={0}// @TODO: leaveTouchDelay={(Platform.OS === 'web' && globals.deviceType !== 'mobile') ? 0 : 1500}// on native and mobile web, there's no such thing as a hover
      {...props}
    >
      {props.children}
    </PaperTooltip>
  );
};

Tooltip.displayName = 'Tooltip';
export default Tooltip;
